import axios from 'axios';
import dayjs from '@/localPlugins/dayjs';
import { getUrl } from '@/config/api.routes';

const getMetrics = (type, { commit }, params, method) => axios[method](getUrl(`pulse.${type}`), params)
  .then(data => {
    const metrics = data.data || {};
    commit('GET_METRICS_SUCCESS', [type, metrics]);
  });

const defaultPollIntervalMs = 45000; // 45 seconds
const defaultTimeslicePeriodMs = dayjs.duration(1, 'days').asMilliseconds();
const ALL_DATA = 99999;

export default {
  namespaced: true,

  state: {
    instant: {
      pollIntervalMs: defaultPollIntervalMs,
      lastFetchedAt: null,
      data: null,
    },
    timeslice: {
      pollIntervalMs: defaultPollIntervalMs,
      periodMs: defaultTimeslicePeriodMs,
      lastFetchedAt: null,
      data: null,
    },
    agents: {
      pollIntervalMs: defaultPollIntervalMs,
      periodMs: defaultTimeslicePeriodMs,
      lastFetchedAt: null,
      data: null,
    },
    pulse365: {
      lastFetchedAt: null,
      data: { total: null, segment_groups: [] },
    },
    my_pulse365: {
      lastFetchedAt: null,
      data: { config: null, total: null, segment_groups: [] },
    },
  },

  getters: {
    instantPollIntervalMs: (state) => state.instant.pollIntervalMs,
    timeslicePollIntervalMs: (state) => state.instant.pollIntervalMs,
  },

  mutations: {
    GET_METRICS_SUCCESS(state, [type, item]) {
      state[type].data = item;
      state[type].lastFetchedAt = Date.now();
    },
  },

  actions: {
    async getInstantMetrics(context, params) {
      const now = dayjs();
      params.period_start = now.unix();
      params.period_end = now.unix();
      return await getMetrics('instant', context, params, 'post');
    },
    async getTimesliceMetrics(context, params) {
      params.period_start = dayjs().startOf('day').unix();
      params.period_end = dayjs().unix();
      return await getMetrics('timeslice', context, params, 'post');
    },
    async getAgentsMetrics(context, params) {
      params.status = 'active';
      params.limit = ALL_DATA;
      return await getMetrics('agents', context, { params }, 'get');
    },
    async getPulse365Metrics(context, params) {
      return await getMetrics('pulse365', context, params, 'post');
    },

    async getMyPulse365Metrics(context, params) {
      return await getMetrics('my_pulse365', context, params, 'post');
    },
  },
};
